"use client";

import dynamic from "next/dynamic";

const PlacesBootFallback = () => (
  <div className="flex h-screen w-full overflow-hidden border-l bg-white pb-12 lg:pb-0">
    <div className="h-full w-full overflow-hidden md:w-[400px] md:min-w-[400px]">
      <div className="px-2 py-5">
        <div className="h-9 w-full rounded-lg bg-black/[0.04]" />
      </div>
      {/* 로딩 자리표시도 실제 필터 줄과 같게 — 분홍 배경을 쓰지 않는다. */}
      <div className="h-10 border-b border-black/5 dark:border-white/10" />
      <div className="flex flex-col divide-y divide-gray-200 px-2">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="flex h-40 w-full items-center gap-4">
            <div className="flex flex-1 flex-col gap-2">
              <div className="h-7 w-28 animate-pulse rounded-xl bg-gray-200" />
              <div className="h-5 w-full animate-pulse rounded-xl bg-gray-200" />
              <div className="h-3.5 w-[80%] animate-pulse rounded-xl bg-gray-200" />
              <div className="h-3 w-20 animate-pulse rounded-xl bg-gray-200" />
            </div>
            <div className="h-32 w-24 min-w-24 animate-pulse rounded-xl bg-gray-200" />
          </div>
        ))}
      </div>
    </div>
    <div className="hidden flex-1 bg-zinc-100 md:block" />
  </div>
);

const ClientOnlyPage = dynamic(() => import("./client"), {
  ssr: false,
  loading: () => <PlacesBootFallback />,
});

export default function ClientOnlyPageWrapper(props) {
  return <ClientOnlyPage {...props} />;
}
